import React from "react";
import { useCountdown } from "../hooks/useCountdown";
export function PromoBar() {
  const time = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-line bg-ink/95 backdrop-blur" data-id="element-123" data-mp="8aqcy0qtiux2">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-2 text-xs sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-124" data-mp="3hnjdsm1jlgv">
        <p className="min-w-0 truncate text-cream" data-id="element-125" data-mp="3uoqa6ixyvpqk">
          <span className="mr-1.5 font-bold tracking-wider text-gold" data-id="element-126" data-mp="3qny1prwx5ovc">PROMO</span>
          <span className="hidden sm:inline" data-id="element-127" data-mp="3lole34y84drp">Le livre + 6 bonus offerts à -60 % — seulement 27 $. L'offre se termine ce soir.</span>
          <span className="sm:hidden" data-id="element-128" data-mp="3gqa1imgjnp5s">Livre + 6 bonus : 27 $</span>
        </p>
        <p className="flex shrink-0 items-center gap-1.5 sm:gap-2" data-id="element-129" data-mp="3bqnooe4moaxi">
          <span className="text-[10px] font-semibold tracking-widest text-mute sm:text-xs" data-id="element-130" data-mp="3bsiea5qugr7x">FIN DANS</span>
          <span className="font-semibold tabular-nums text-gold" data-id="element-131" data-mp="19yrgneho5j7h">{time}</span>
        </p>
      </div>
    </div>;
}